import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";

interface mutateProps {
  id: string;
  module: string;
  communityId: string;
}

const mutateToggleStatus = async ({ id, communityId, module}: mutateProps) => {
  return await axiosAuth.patch(`v1/${module}/community/${communityId}/${id}/toggle-status`);
};

const useToggleStatusMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateToggleStatus,
    ...queryParams,
  });

export default useToggleStatusMutation;
